export const COVER_IMAGE_CONTAINER_ID =
  "standard-layout-v2-cover-image-container";
export const coverImageSelector = `#${COVER_IMAGE_CONTAINER_ID}`;

export const STANDARD_LAYOUT_HEADER_ID = "standard-layout-header";
export const standardLayoutHeaderSelector = `#${STANDARD_LAYOUT_HEADER_ID}`;
